module.exports = __webpack_public_path__ + "img/home.0cf12952.jpg";